// eslint-disable-next-line import/no-anonymous-default-export
export default `<div role='tooltip' class="tds-theme tds-theme-background tds-theme-border tds-theme-tip tds-flex
tds-flex-auto tds-overflow-auto tds-shadow-popout tds-rounded-[min(theme(borderRadius.themeCornerSize),10px)]
tds-flex tds-p-xs">
  <span data-tooltip-message></span>
</div>`;
